(function(window, document, $) {
//	TODO refactor based on percentages
	class Magic {
		constructor($container) {
			this.$container		= $container;
			this.activeClass	= 'z-index-2';
			this.inactiveClass	= 'z-index-0';
			this.className		= 'focus-slide-';
			this.part			= 21;
			this.breakpoint		= 768;
			this.currentClassId	= '';
			this.classId		= '';
			this.$currentSlide	= '';
			this.maxDistance	= 420;
			this.divider		= this.maxDistance / this.part;
		}

		init() {
			// console.log('gdf');
			// empty the container
			this.$container.find('.' + this.activeClass).remove();
			// just in case...
			this.$container.find('.' + this.inactiveClass).remove();
			// build the structure
			let i;
			for (i = 0; i < this.part; i++) {
				this.$container.append("<div class='" + this.className + i + ' ' + this.inactiveClass + "'></div>");
			}
			// set the active class
			this.$container.find('.' + this.inactiveClass).last().removeClass(this.inactiveClass).addClass(this.activeClass);

			this.registerEventHandler();
		}

		registerEventHandler() {
			var self = this;
			$(document).mousemove(function(e) {
				if(self.isResolutionLargerThanBreakpoint()) {
					self.classId		= 0;
					self.$currentSlide	= self.$container.find('.' + self.activeClass);
					self.currentClassId = self.$currentSlide.attr('class').slice(self.className.length).slice(0, -1 * self.activeClass.length);
					// console.log('current: ' + currentClassId);
					const hypot = self.getDistanceFromObject(e);

					// console.log(hypot);

					if (hypot <= self.maxDistance) {
						let classId = Math.floor(hypot / self.divider);
						// console.log('mouse: ' + classId);
						self.changeClasses(classId);
					}
				} else if (!self.isLastSlideActive()) {
					self.init();
				}
			});
		}

		isResolutionLargerThanBreakpoint() {
			return window.innerWidth > this.breakpoint;
		}

		isLastSlideActive() {
			console.log(this.$container.find('div').last().hasClass(this.activeClass));
			return this.$container.find('div').last().hasClass(this.activeClass);
		}

		changeClasses(classId) {
			if (this.currentClassId != classId && classId >= 0 && classId < this.part) {
				const nextClass = this.className + classId;
				// set the class of the current slide
				// console.log(this.$currentSlide);
				this.$currentSlide.removeClass(this.activeClass).addClass(this.inactiveClass);
				// set the class of the active slide
				this.$container.find('.' + nextClass).removeClass(this.inactiveClass).addClass(this.activeClass);
				// console.log('done');
			}
		}

		getDistanceFromObject(event) {
			const mX			= event.pageX;
			const mY			= event.pageY;
			const from			= { x: mX, y: mY };

			const off = this.$container.offset(),
				nx1 = off.left,
				ny1 = off.top,
				nx2 = nx1 + this.$container.outerWidth(),
				ny2 = ny1 + this.$container.outerHeight(),
				maxX1 = Math.max(mX, nx1),
				minX2 = Math.min(mX, nx2),
				maxY1 = Math.max(mY, ny1),
				minY2 = Math.min(mY, ny2),
				intersectX = minX2 >= maxX1,
				intersectY = minY2 >= maxY1,
				to = {
					x: intersectX ? mX : nx2 < mX ? nx2 : nx1,
					y: intersectY ? mY : ny2 < mY ? ny2 : ny1
				};
			// distance from $container
			const distX = to.x - from.x,
				distY = to.y - from.y,
				hypot = Math.sqrt(distX * distX + distY * distY);
			return hypot;
		}
	}

	$(document).ready(function() {
		const $container	= $('#focus-container');
		if ($container.length > 0) {
			const focus = new Magic($container);
			focus.init();
			focus.registerEventHandler();
		}
	});
})(window, document, jQuery);



// WEBPACK FOOTER //
// ./assets/scripts/focus.js